/*
  GiftGo product-card add-to-cart icon button.

  Adds the card product's first available variant to the cart over Dawn's cart
  AJAX, then lets Dawn's own cart UI (cart-notification or cart-drawer) re-render
  its sections, so the cart count bubble and the cart update exactly as they do
  from the product page. No page reload. Reuses Dawn globals: fetchConfig,
  routes, PUB_SUB_EVENTS, publish.
*/
(function () {
  'use strict';

  class GiftGoAddToCart extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      if (this.button && !this.bound) {
        this.bound = true;
        this.button.addEventListener('click', this.onClick.bind(this));
      }
    }

    onClick(event) {
      event.preventDefault();
      event.stopPropagation();

      var variantId = this.dataset.variantId;
      if (!variantId || this.loading) return;

      this.loading = true;
      this.classList.add('is-loading');
      this.button.setAttribute('aria-busy', 'true');

      var cart =
        document.querySelector('cart-notification') || document.querySelector('cart-drawer');

      var config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      var formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', 1);

      if (cart && typeof cart.getSectionsToRender === 'function') {
        formData.append(
          'sections',
          cart.getSectionsToRender().map(function (s) {
            return s.id;
          })
        );
        formData.append('sections_url', window.location.pathname);
        cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(routes.cart_add_url, config)
        .then(function (response) {
          return response.json();
        })
        .then(
          function (response) {
            if (response.status) {
              // Sold out / not addable. Leave the page as is.
              return;
            }
            if (cart && typeof cart.renderContents === 'function') {
              cart.renderContents(response);
            }
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'giftgo-card-add', productVariantId: variantId });
            }
          }.bind(this)
        )
        .catch(function () {})
        .finally(
          function () {
            this.loading = false;
            this.classList.remove('is-loading');
            this.button.removeAttribute('aria-busy');
          }.bind(this)
        );
    }
  }

  if (!customElements.get('giftgo-add-to-cart')) {
    customElements.define('giftgo-add-to-cart', GiftGoAddToCart);
  }
})();
